module.exports = __webpack_public_path__ + "static/habStill10-316ef64e209542cd83379b0229e2dd45.png";